import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';

import { CATEGORY_VISIBILITY } from '../../utilities/CONSTANTS';

const PAGE_DEFAULT = 0;
const PAGE_LOCKED = 1;

const getVisibilityText = () => {
    let viewLabel; let
        editLabel;
    const { category_id } = window._tettraDraft;
    const isNewCategory = category_id && isNaN(parseInt(category_id));
    let visibility = CATEGORY_VISIBILITY.TEAM_VISIBLE;

    if (category_id && !isNewCategory) {
        visibility = window.categoriesAndFoldersMap[category_id].visibility;
    }

    if (visibility === CATEGORY_VISIBILITY.PUBLIC_VISIBLE) {
        viewLabel = 'The public';
        editLabel = `Everyone at ${window.teamName}`;
    } else if (visibility === CATEGORY_VISIBILITY.TEAM_VISIBLE) {
        viewLabel = `Everyone at ${window.teamName}`;
        editLabel = `Everyone at ${window.teamName}`;
    } else if (visibility === CATEGORY_VISIBILITY.PRIVATE_VISIBLE) {
        viewLabel = 'Only invited team members';
        editLabel = `Everyone who can view ${categoriesAndFoldersMap[category_id].name}`;
    }

    return { viewLabel, editLabel };
};

class ChangePagePermissionsModal extends React.Component {
    state = { selectedOption: null };

    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return this.props.closeModal();
        }
    };

    onChangeRadio = ({ target: { value } }) => {
        const selectedOption = parseInt(value);

        return this.setState({ selectedOption });
    };

    onSave = () => {
        const isLocked = this.getIsLocked();
        window._tettraDraft.is_locked = isLocked;

        return this.props.closeModal();
    };

    getIsLocked = () => {
        const { selectedOption } = this.state;

        if (selectedOption !== null) {
            return selectedOption;
        }

        if (selectedOption === null && window._tettraDraft) {
            return !!window._tettraDraft.is_locked;
        }

        return PAGE_DEFAULT;
    };

    render() {
        const isLocked = this.getIsLocked();
        const { viewLabel, editLabel } = getVisibilityText();
        return (
            <div className="react-modal open" onMouseDown={this.onClickModal}>
                <div className="modal-content p2">
                    <h2>Page permissions</h2>
                    <div>
                        <label className="bold block col-12 mb1">Who can view this page?</label>
                        <label>
                            <input checked type="radio" readOnly />
                            <span>{viewLabel}</span>
                        </label>
                        <span className="gray italic ml3">Set by the category</span>
                    </div>
                    <div className="mt2">
                        <label htmlFor="pagePermissions" className="bold block col-12 mb1">Who can edit this page?</label>
                        <div>
                            <label>
                                <input checked={isLocked == PAGE_DEFAULT} name="pagePermissions" type="radio" value={PAGE_DEFAULT} onChange={this.onChangeRadio} />
                                <span>{editLabel}</span>
                            </label>
                        </div>
                        <div>
                            <label>
                                <input checked={isLocked == PAGE_LOCKED} name="pagePermissions" type="radio" value={PAGE_LOCKED} onChange={this.onChangeRadio} />
                                Only page owners and admins
                            </label>
                        </div>
                    </div>
                    <div className="mt2 right-align">
                        <span className="btn-secondary mr1" onClick={this.props.closeModal}>Cancel</span>
                        <span className="btn btn-primary" onClick={this.onSave}>Save</span>
                    </div>
                </div>
            </div>
        );
    }
}

class ChangePagePermissions extends React.Component {
    state = {
        showModal: false,
    };

    render() {
        const { showModal, selectedOption } = this.state;
        return (
            <Fragment>
                <span className="dropdown-option link" onClick={() => this.setState({ showModal: true })}>Page permissions</span>
                {showModal && createPortal(<ChangePagePermissionsModal closeModal={() => this.setState({ showModal: false })} />, document.body)}
            </Fragment>
        );
    }
}

export default ChangePagePermissions;
